<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      v-model:page="page"
      @row-del="rowDel"
      v-model="form"
      ref="crud"
      :permission="permissionObj"
      @row-update="rowUpdate"
      @row-save="rowSave"
      :before-open="beforeOpen"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="refreshChange"
      @on-load="onLoad"
    >
      <template #menu-left>
        <el-button
          type="danger"
          icon="el-icon-delete"
          plain
          v-if="permission.client_delete"
          @click="handleDelete"
          >{{ Lang.btn.delete }}
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { getList, getDetail, add, update, remove } from '@/api/system/client';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 104,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        indexLabel: this.Lang.table.serialNumber,
        indexWidth: '100%',
        viewBtn: true,
        grid: true,
        selection: true,
        dialogClickModal: false,
        column: [
          {
            label: this.Lang.label.appid,
            prop: 'clientId',
            search: true,
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzInputAppid,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.label.appSecret,
            prop: 'clientSecret',
            search: true,
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzInputAppSecret,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.label.authType,
            prop: 'authorizedGrantTypes',
            type: 'checkbox',
            value: 'refresh_token,password,authorization_code,captcha,social,sms_code,register',
            dicData: [
              {
                label: 'refresh_token',
                value: 'refresh_token',
              },
              {
                label: 'password',
                value: 'password',
              },
              {
                label: 'authorization_code',
                value: 'authorization_code',
              },
              {
                label: 'captcha',
                value: 'captcha',
              },
              {
                label: 'social',
                value: 'social',
              },
              {
                label: 'sms_code',
                value: 'sms_code',
              },
              {
                label: 'register',
                value: 'register',
              },
            ],
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzInputAuthType,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.label.authScope,
            prop: 'scope',
            value: 'all',
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzInputAuthScope,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.label.accessTokenSeconds,
            prop: 'accessTokenValidity',
            type: 'number',
            value: 3600,
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzInputAccessTokenTimeoutSec,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.label.refreshSecconds,
            prop: 'refreshTokenValidity',
            type: 'number',
            value: 604800,
            hide: true,
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzInputRefreshTokenTimeoutSec,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.label.callbackAddress,
            prop: 'webServerRedirectUri',
            hide: true,
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzInputCallbackAddress,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.label.autoApprove,
            prop: 'autoapprove',
            hide: true,
            type: 'radio',
            dicData: [
              {
                label: this.Lang.label.yes,
                value: 'true',
              },
              {
                label: this.Lang.label.no,
                value: 'false',
              },
            ],
            value: 'true',
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzInputAutoApprove,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.label.assetsCollect,
            prop: 'resourceIds',
            hide: true,
            rules: [
              {
                message: this.Lang.label.plzInputAssetsCollect,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.label.authorization,
            prop: 'authorities',
            hide: true,
            rules: [
              {
                message: this.Lang.tips.plzInputAuth,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.label.additionInformation,
            hide: true,
            prop: 'additionalInformation',
            span: 24,
            rules: [
              {
                message: this.Lang.tips.plzInputAdditionInformation,
                trigger: 'blur',
              },
            ],
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['menuItem', 'permission']),
    permissionObj() {
      const keys = Object.keys(this.permission)
      const obj = {}
      const menuId = this.menuItem.id;
      keys.forEach((key => {
        if (key.indexOf(menuId) > -1) {
          const btnType = key.substr(menuId.length);
          obj[btnType] = true;
          obj[btnType+'Btn'] = true; // 兼容
          if (btnType === 'delete') {
            obj.delBtn = true;
          }
        }
      }))
      return obj
    },
    ids() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          done();
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          done();
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm(this.Lang.tips.ifConfirmDelete, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return remove(row.id);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
        });
    },
    searchReset() {
      this.query = {};
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.Lang.tips.plzSelectOne);
        return;
      }
      this.$confirm(this.Lang.tips.ifConfirmDelete, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return remove(this.ids);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail(this.form.id).then(res => {
          this.form = res.data.data;
        });
      }
      done();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad(page, params = {}) {
      this.loading = true;
      getList(page.currentPage, page.pageSize, Object.assign(params, this.query)).then(res => {
        const data = res.data.data;
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
        this.selectionClear();
      });
    },
  },
};
</script>

<style></style>
